import { render, staticRenderFns } from "./menuShopCart.vue?vue&type=template&id=25d991f0&scoped=true&"
import script from "./menuShopCart.vue?vue&type=script&lang=ts&"
export * from "./menuShopCart.vue?vue&type=script&lang=ts&"
import style0 from "./menuShopCart.vue?vue&type=style&index=0&id=25d991f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d991f0",
  null
  
)

export default component.exports